import Swiper from 'swiper/bundle'
import { gsap } from 'gsap'

/**
 * GlobalHeader functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class GlobalHeader {
  /**
   * Constructs a new GlobalHeader instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.navToggle = this.element.querySelector('[data-component="nav-toggle"]')
    this.mainNav = this.element.querySelector('[data-component="main-nav"]')
    this.navItems = this.mainNav.queryAll('ul > li.has-submenu')
    this.bannerSlider = this.element.querySelector('[data-component="banner-slider"]')
    this.bannerSliderSwiper = this.bannerSlider.querySelector('.swiper-container')
    this.mobileMediaQuery = window.matchMedia('(max-width: 73.75em)')

    var slider = new Swiper(this.bannerSliderSwiper, {
      loop: true,
      slidesPerView: 1,
      effect: 'fade',
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      allowTouchMove: false,
      fadeEffect: {
        crossFade: true
      }
    })

    // const mainNav = gsap.timeline({
    //   paused: true,
    //   reversed: true
    // })

    // mainNav
    // .to(this.mainNav, {
    //   x: 0,
    //   duration: 0.5,
    //   ease: 'power2'
    // })

    // function menuIn() {
    //   mainNav.reversed() ? mainNav.play() : mainNav.reverse()
    // }

    this.navToggle.addEventListener('click', e => {
      this.navToggle.classList.toggle('is-active')
      document.body.classList.toggle('nav-open')
      // menuIn()
    })

    if (this.mobileMediaQuery.matches) {
      this.navItems.forEach(element => {
        const toggle = element.querySelector('a')
        toggle.addEventListener('click', e => {
          var index = this.navItems.indexOf(element)
          if (element.classList.contains('open')) {
            this.close(this.navItems)
            e.preventDefault()
          } else {
            e.preventDefault()
            this.close(this.navItems)
            this.open(element, index)
          }
        })
      })
    }
  }

  // Closes expanded state.
  close (navItems) {
    this.navItems.forEach(element => {
      element.classList.remove('open')
    })
  }

  // Opens expanded state.
  open (element, index) {
    element.classList.add('open')
  }

}



// WEBPACK FOOTER //
// ./components/global-header/index.js